<template>
    <el-row  type="flex" class="el-row" justify="center">
      <el-col  :xl="6" :lg="7">
        <div class="login-form">
          <h2>欢迎来到管理系统</h2>
          <el-image
              style="width: 180px; height: 180px"
              :src="require('@/assets/download.png')"
          ></el-image>
          <br>
          <el-link type="primary"  href="http://api.gw.duhongtech.com/sight/app/apk/newapk">扫描上方二维码或点击链接下载app</el-link>
        </div>
      </el-col>
      <el-col :span="1">
        <el-divider  direction="vertical"></el-divider>
      </el-col>
      <el-col  :xl="6" :lg="7">
        <el-form label-position="right" :rules="rules" label-width="80px" :model="loginForm" ref="loginForm">
          <el-form-item label="用户名" prop="username" style="width: 380px;">
            <el-input v-model="loginForm.username"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" style="width: 380px;">
            <el-input type="password" v-model="loginForm.password"></el-input>
          </el-form-item>
<!--          验证码-->
<!--          <el-form-item label="验证码" prop="code" style="width: 380px;">-->
<!--            <el-input v-model="loginForm.code" style="width: 172px; float: left;" maxlength="5"></el-input>-->
<!--            <el-image class="captchaImg" :src="captchaImg" @click="getCaptcha"></el-image>-->
<!--          </el-form-item>-->
          <el-form-item>
            <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
            <el-button @click="resetForm('loginForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </template>

<script>
import qs from 'qs'
import axios from "@/axios";
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
      },
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
      },
      captchaImg: ''
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          axios({
            method:"post",
            url:"/sys/login",
            data:{
              username: this.loginForm.username,
              password: this.loginForm.password,
            },
          }).then(res => {
            // console.log(res.data)
            // 将token存储到应用store中
            if(res.data.code == "0000"){
                const token = res.data.data.token
                const expire = res.data.data.expire
                this.$store.commit("SET_TOKEN", token)
                this.$store.commit("SET_EXPIRE",expire)
                // console.log(localStorage.getItem('expire'))
                // console.log(localStorage.getItem('token'))
                this.$router.push("/sys/index")
            }
          }).catch(error => {
            // this.getCaptcha();
            console.log('error submit!!');
          })
        } else {
          // this.getCaptcha();
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // getPass() {
    //   this.$message("请扫描左边的二维码，回复【VueAdmin】获取登录密码");
    // },
    // getCaptcha() {
    //   this.$axios.get('/captcha').then(res => {
    //     this.loginForm.token = res.data.data.token
    //     this.captchaImg = res.data.data.captchaImg
    //   })
    // }
  },
  // created() {
  //   this.getCaptcha()
  // }
}
</script>

<style scoped>
  .el-col{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
  }

  .el-row {
    height: 100%;
    background-color: #fafafa;
  }
  .el-divider {
  height: 200px;
  }
  .captchaImg {
    float: left;
    margin-left: 8px;
    border-radius: 4px;
  }
</style>
